<template>
  <transition name="fade">
    <div class="dialog-mask">
      <div ref="dialogWrapper" class="dialog-wrapper animated fadeInUp">
        <div class="dialog-container">
          <div class="dialog-header">{{ title }}</div>
          <div class="dialog-body">
            <slot />
          </div>
          <div class="dialog-footer">
            <div class="col-2" @click="dialogClose">{{ cancel }}</div>
            <div class="col-2" @click="submit">{{ confirm }}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'MyPop',
  props: {
    title: {
      type: String,
      default: ''
    },
    cancel: {
      type: String,
      default: '取消'
    },
    confirm: {
      type: String,
      default: '确认'
    }
  },
  data() {
    return {
    }
  },
  methods: {
    dialogClose() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/index.scss';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.dialog-mask {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  display: table;
  animation-duration: 0.6s;
  animation: show .3s;
  .dialog-wrapper {
    display: table-cell;
    vertical-align: middle;
    animation-duration: 0.3s;
    .dialog-container {
      margin: auto;
      top: 0;
      background-color: white;
      width: 320px;
      min-height: 50px;
      height: auto;
      border-radius: 15px;
      overflow: hidden;
      animation-duration: 0.3s;
      animation: move .3s;
      .dialog-header {
        min-height: 0;
        height: auto;
        overflow: hidden;
        color: #333333;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        box-sizing: border-box;
        padding: 20px 10px 0 10px;
        position: relative;
      }
      .dialog-body {
        min-height: 0;
        height: auto;
        overflow: hidden;
        line-height: 24px;
        font-size: 14px;
        color: #999999;
        box-sizing: border-box;
        padding:10px;
        position: relative;
        &::after{
          @extend %border-bottom;
        }
      }
      .dialog-footer {
        height: 50px;
        width: 100%;
        background-color: #ffffff;
        box-sizing: border-box;
        position: relative;
        .col-2{
          width: 50%;
          float: left;
          position: relative;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 15px;
          color: #787878;
          &:nth-of-type(2){
            background:#eea105;
            color: #ffffff;
          }
        }
      }
    }
  }
  @keyframes move{
    0%{
      transform: scale(1);  /*开始为原始大小*/
    }
    50%{
      transform: scale(1.1);
    }
    100%{
      transform: scale(1);
    }
  }
   @-webkit-keyframes move{
    0%{
      transform: scale(1);  /*开始为原始大小*/
    }
    50%{
      transform: scale(1.1);
    }
    100%{
      transform: scale(1);
    }
  }
   @keyframes show{
     0%{
     opacity: 0;
    }
    50%{
      opacity: 0.5;
    }
    100%{
      opacity: 1;
    }
  }
   @-webkit-keyframes show{
    0%{
     opacity: 0;
    }
    50%{
      opacity: 0.5;
    }
    100%{
      opacity: 1;
    }
  }
}
</style>
